// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueRouter from 'vue-router';

//全局引入axios
import "babel-polyfill"
import axios from 'axios'
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.baseURL = 'http://yxpx_api.jxjyedu.club'

Vue.prototype.$axios = axios
Vue.use(VueRouter);

//全局引入公共header和footer
// import commonHeader from '@/commons/header'
// Vue.component("commonHeader", commonHeader)
// import commonFooter from '@/commons/footer'
// Vue.component("commonFooter", commonFooter)

//全局引入loading
import loading from '@/commons/loading'
Vue.component("loading", loading)
import Router from 'vue-router'
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
        return routerPush.call(this, location).catch(error => error)
    }
    //全局引入iconfont
    // import VueTouch from '../node_modules/vue-touch/vue-touch'
    // Vue.use(VueTouch, { name: 'v-touch' })
import './assets/iconfont/iconfont.css'
import './style/reset.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import VueVideoPlayer from 'vue-video-player'
// import store from './store/index'
Vue.use(VueVideoPlayer)
Vue.config.productionTip = false
import store from '../src/store/index'
/* eslint-disable no-new */
const vv = new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})


router.afterEach((to, from, next) => {
    window.scrollTo(0, 0)
});


// WEBPACK FOOTER //
// ./src/main.js